import React, { useEffect, useState } from 'react';
import sortBy from 'lodash/sortBy';
import {
  InputContainerPropsSingle,
  Typeahead,
} from 'react-bootstrap-typeahead';
import { TekionEntity } from '@upstart/harmony/lib/legos/dmsTypes';

type Props = {
  tekionEntities: TekionEntity[];
  selected: TekionEntity;
  onChange: InputContainerPropsSingle<TekionEntity>['onChange'];
};

export default function TekionTypeahead(props: Props) {
  const { tekionEntities, selected, onChange } = props;

  const [selectedEntity, setSelectedEntity] = useState<TekionEntity[]>([]);

  useEffect(() => {
    setSelectedEntity(selected ? [selected] : []);
  }, [selected]);

  return (
    <Typeahead
      id="tekion-typeahead"
      className="picker"
      inputProps={{
        shouldSelectHint: (shouldSelect, event) =>
          event.key === 'Enter' || shouldSelect,
      }}
      clearButton
      // only pass the default if there is one
      selected={selectedEntity}
      options={sortBy(tekionEntities, [dte => dte.desc])}
      filterBy={['desc']}
      labelKey={'desc'}
      onChange={(newEntity: TekionEntity[]) => {
        setSelectedEntity(newEntity);
        onChange(newEntity);
      }}
    />
  );
}
